module.exports = __webpack_public_path__ + "img/empty-inbox.5423857c.svg";